// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1ekVO","topBottomGutter":"Layout_topBottomGutter__3gCx1"};